'use client';

import CurrencyIcon from '@/components/ui/icons/currency-icon';
import MiniCartItem from './mini-cart-item';
import { useTranslations } from 'next-intl';
import { priceFormatedObject, validatePrice } from '@/utils/category';
import { handlePriceByComma } from '@/helpers/common';
import NextLink from '@/components/next-link';

const MiniCart = ({ cartItems, total }) => {
  const t = useTranslations('common');

  return (
    <div className='red-scroll absolute end-1/2 top-full z-[200] hidden max-h-[450px] w-[350px] overflow-y-auto rounded-md bg-white p-3 pb-0 shadow group-hover:block ltr:translate-x-1/2 rtl:-translate-x-1/2'>
      <ul className='red-scroll max-h-[280px] overflow-y-auto'>
        {cartItems?.map((product) => {
          const price = validatePrice(priceFormatedObject(product));
          return (
            <MiniCartItem
              href={`/product/${
                product?.rewrite_url ||
                product?.url_key?.[0] ||
                product?.extension_attributes?.url_key
              }`}
              image={
                product?._media_?.image?.at(0)?.image ||
                (product?.extension_attributes?.product_image &&
                  `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${product?.extension_attributes?.product_image}`)
              }
              name={product?.name}
              price={
                price?.final_price ||
                product?.price_incl_tax ||
                price?.originalPrice
              }
              item_id={product?.item_id}
              quantity={product?.qty}
              key={product?.item_id}
            />
          );
        })}
      </ul>
      <div className='my-2 flex items-center justify-center gap-5'>
        <span className='font-semibold'>{t('total_key')} </span>
        <span className='flex items-center gap-1 font-bold text-red-600'>
          {handlePriceByComma(total || 0)} <CurrencyIcon className='size-3.5' />
        </span>
      </div>
      <NextLink
        href={'/cart'}
        className='mb-3 flex w-full cursor-pointer items-center justify-center rounded-md border border-red-600 p-1.5 font-semibold text-red-600 hover:bg-red-600 hover:text-white'
      >
        {t('View and Edit My Cart')}
      </NextLink>
      <NextLink
        href={'/checkout'}
        className='hover:border-rd-400 mb-3 flex w-full cursor-pointer items-center justify-center rounded-md border border-red-600 bg-red-600 p-1.5 font-semibold text-white hover:border-red-400 hover:bg-red-400'
      >
        {t('Checkout')}
      </NextLink>
    </div>
  );
};

export default MiniCart;
